import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import CONF from '../config/config.js';
import errorImg from './../assets/img/error.png';
import successImg from './../assets/img/success.png';

export default class GenericFileUploader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: null,
			uploading: false,
			uploadStatus: null
		};
		this.setUploadStatus = this.setUploadStatus.bind(this);
		this.clear = this.clear.bind(this);
	}

	//check if file size is above limit
    fileSizeInLimit(file) {
        if (!file) {
            return false;
        }

		const { fileSizeLimit } = this.props;

        var sizeOfFileReceived = file.size;
        var limit = Number(fileSizeLimit);
		let errorFileSize =
    		'File size too large. To reduce size try copying data into a new sheet and ingest. Maximum allowed size of the file being ingested is ' +
			Number(fileSizeLimit) / 1000000 +
    		'MB .For further queries contact tech support.';

        if (!limit) {
            //default limit
            limit = CONF.DEFAULT_FILE_SIZE_LIMIT_FOR_INGESTION_IN_BYTES; // 2MB
			errorFileSize =
			'File size too large. To reduce size try copying data into a new sheet and ingest. Maximum allowed size of the file being ingested is ' +
			CONF.DEFAULT_FILE_SIZE_LIMIT_FOR_INGESTION_IN_BYTES / 1000000 +
			'MB .For further queries contact tech support.';
        }

        if (sizeOfFileReceived > limit) {
            const status = {
                title: 'Error uploading file',
                statusCss: 'failure-text',
                icon: errorImg,
                message: errorFileSize,
            };
            this.setState({
                uploadStatus: status,
            });
            return false;
        }

        return true;
    }

	setUploadStatus(isSuccess, message) {
		this.setState({
			uploading: false
		})
		var status;
		if (isSuccess) {
			status = {
				title: 'File uploaded successfully.',
				statusCss: 'success-text',
				icon: successImg,
				message: [message]
			};
		} else {

			if (!message) {
				status = {
					title: 'File upload cancelled!',
					statusCss: 'failure-text',
					icon: errorImg,
					message: ['Cancelled by user.']
				};
			} else {
				status = {
					title: 'Error uploading file',
					statusCss: 'failure-text',
					icon: errorImg,
					message: message.error
				};
			}
		}
		this.setState({
			uploadStatus: status
		})
	}

	onDrop(files) {
		const { handleFileDrop } = this.props;
		var file = files[0];
		if (file && this.fileSizeInLimit(file)) {
			handleFileDrop(file);
			this.setState({
				file: file,
			});
		}
	}

	showMessage(message) {
		if (typeof (message) === 'string') {
			return <span>{message}</span>
		}
		return message.map((msg, index) => <span key={index}>{msg}<br /></span>);
	}

	clear() {
		const { uploading } = this.state;
		if (!uploading) {
			this.setState({
				file: null,
				uploadStatus: null
			});
		}
	}

	cancelUpload() {
		alert("Upload Cancelled!");
	}

	render() {
		let dropzoneRef;
		const { noMessage, accept } = this.props;
		const { file, uploading, uploadStatus } = this.state;

		return (
			<div className="drop-outer-box">
				{(!noMessage) ?
					<div className='upload-file-msg'>
						Please Upload your file here :
					</div> : null
				}
				<Dropzone 
					ref={(node) => { dropzoneRef = node; }} 
					onDrop={(files) => this.onDrop(files)} 
					className="drop-wrapper" 
					accept={accept ? accept : '.xls,.xlsx'} 
					disableClick={true}
				>
					{(!file) ?
						<div>
							<div className="drop-instruction">
								Drag and Drop file here
							</div>
							<div className="drop-instruction">
								OR
							</div>
							<div className="drop-instruction" style={{ padding: '10px' }}>
								<span 
									className="choose-file" 
									onClick={() => { dropzoneRef.open() }}
								>
									Choose file
								</span>
							</div>
						</div>
						: null
					}
					{(uploading && !uploadStatus) ?
						<div>
							<div className="drop-instruction">
								Uploading...
							</div>
							<div className="drop-instruction">
								<small className="text-muted">{file.name}</small>
							</div>
							<div className="drop-instruction">
								<button className="btn btn-primary" onClick={this.cancelUpload}>Cancel</button>
							</div>
						</div> : null
					}
					{(uploadStatus) ?
						<div>
							<p className={"left upload-status " + uploadStatus.statusCss}>
								<img src={uploadStatus.icon} alt="upload icon" />
								<b>{uploadStatus.title}</b>
								<br />
								<span>{this.showMessage(uploadStatus.message)}</span>
							</p>
							<button 
								className="btn btn-default upload-again-btn" 
								onClick={this.clear} 
							>
								Upload Again
							</button>
						</div> : null
					}
				</Dropzone>
				{(!noMessage) ?
					<div className='upload-xlsx-msg'>
						<span className='red-color'>Note:</span> Please Upload only .xlsx files
					</div> : null
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/commons/GenericFileUploader.js